import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import { appSlice } from '../../../../store/slices';
import { createRootModal } from '../../RootModal';

import './ChoosePeriodModal.scss';

const ARROW_SIZE = 20;

const ChoosePeriodModal = createRootModal(({ handleClose }) => {
	const { changePeriod } = useSelector(state => state.app.modal.outsideParams);

	const dispatch = useDispatch();

	const getPeriodSrart = days => {
		const date = new Date();
		date.setDate(date.getDate() - days);
		return date;
	};

	const periods = [
		{
			label: 'Last week',
			dateFrom: getPeriodSrart(7),
			datoTo: new Date(),
		},
		{
			label: 'Last month',
			dateFrom: getPeriodSrart(30),
			datoTo: new Date(),
		},
		{
			label: 'Last year',
			dateFrom: getPeriodSrart(365),
			datoTo: new Date(),
		},
	];

	const selectPeriod = (dateFrom, datoTo) => {
		changePeriod([dateFrom, datoTo]);
		handleClose();
	};

	const openPeriodSelectModal = () => {
		dispatch(
			appSlice.actions.updateModal({
				title: <span>{t('Select period')} (UTC +0)</span>,
				tag: 'PeriodSelectModal',
				isOpen: true,
				outsideParams: { selectPeriod },
			})
		);
	};

	return (
		<div className='ChoosePeriodModal'>
			{periods.map((period, index) => (
				<div
					className='ChoosePeriodModal__period-item'
					onClick={() => selectPeriod(period.dateFrom, period.datoTo)}
					key={index}
				>
					<div className='ChoosePeriodModal__period-label'>{t(period.label)}</div>
					<div className='ChoosePeriodModal__period-dates'>
						{HelperService.formatDate(period.dateFrom, '.', 10, '', false, true)} -{' '}
						{HelperService.formatDate(period.datoTo, '.', 10, '', false, true)}
					</div>
				</div>
			))}
			<div className='ChoosePeriodModal__period-item' onClick={openPeriodSelectModal}>
				<div className='ChoosePeriodModal__period-label'>{t('Custom')}</div>
				<div className='ChoosePeriodModal__period-dates'>
					<Icon className='ChoosePeriodModal__arrow' type={Icons.NEXT_ARROW} width={ARROW_SIZE} height={ARROW_SIZE} />
				</div>
			</div>
		</div>
	);
});

export default ChoosePeriodModal;
